export enum UserAchievementsType {
	HundredTrades = 'hundred-completed-trades',
	TwoHundredTrades = 'two-hundred-completed-trades',
	ThousandTrades = 'thousand-completed-trades',
	SlateWinner = 'slate-winner',
	GoodFriend = 'good-friend',
	LinkedAvatarBorder = 'linked-avatar-border',
	CommunityBuilderBadge = 'community-builder-badge',
	TheKickOff = 'the-kick-off',
	FirstServe = 'first-serve',
	LockedIn = 'locked-in',
	Rookie = 'rookie',
	NationalPride = 'national-pride',
	MatchChampion = 'match-champion',
	PlatinumElite = 'platinum-elite',
	GoldStar = 'gold-star',
	SilverPro = 'silver-pro',
	BronzeInitiate = 'bronze-initiate',
	BaselineContributor = 'baseline-contributor',
	AlwaysLocked = 'always-locked',
	AllStar = 'all-star',
	Superstar = 'superstar',
	PublicSignal = 'public-signal',
	TheOnePercentClub = 'the-one-percent-club',
	CenterCourt = 'center-court',
	TheWholeDraw = 'the-whole-draw',
}
